/* eslint-disable prettier/prettier */
import * as React from "react";
import { Stack } from "@mui/material";

import AssignedPrograms from "./action_center/AssignedPrograms";
import AssignedProviderActions from "./action_center/AssignedProviderActions";
import PatientActionQueue from "./action_center/PatientActionQueue";

interface Props {
  refreshActionQueue?: string
}

const ActionCenter: React.FC<Props> = (props: Props) => {
  const [refreshPrograms, setRefreshPrograms] = React.useState<boolean>(false);
  return (
    <Stack gap={0}>
      <PatientActionQueue reloadPrograms={setRefreshPrograms} refreshActionQueue={props?.refreshActionQueue} />
      <AssignedPrograms refreshPrograms={refreshPrograms} setRefreshPrograms={setRefreshPrograms} />
      <AssignedProviderActions refreshData={refreshPrograms} setRefreshData={setRefreshPrograms} />
    </Stack>
  );
};

export default ActionCenter;
